/**
 * Driver constants for routing within the CX Driver module.
 */
export class DriverRoutingConstants {

	/**
	 * The base folder route to the CX Driver module.
	 */
	public static readonly ROUTES_BASE_FOLDER: string = 'driver';

	/**
	 * The route to the services preview page.
	 */
	public static readonly ROUTES_SERVICES_PREVIEW: string = 'service-preview';

	/**
	 * The route to the en route page.
	 */
	public static readonly ROUTES_EN_ROUTE: string = 'en-route-to-stop';

	/**
	 * The route to the perform service page.
	 */
	public static readonly ROUTES_PERFORM_SERVICE: string = 'perform-service';

	/**
	 * The route to the completed review page
	 */
	public static readonly ROUTES_COMPLETED_REVIEW: string = 'completed-review';

	/**
	 * The route to the end of shift page.
	 */
	public static readonly ROUTES_END_OF_ROUTE: string = 'end-of-route';
}